import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { FormCard, FormPageContainer, FormPageHeader } from '@/components/PageLayout';
import { useCategories } from '@/hooks/useCategoryQueries';
import { useListReturn } from '@/hooks/useListReturn';
import { ROUTES } from '@/routes/routes';
import { findCategoryInTree } from '@/utils/categoryUtils';

import { EditCategoryForm } from './EditCategoryForm';

export const EditCategoryPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { goToList } = useListReturn(ROUTES.CATEGORIES);
  const { data: categories, isLoading } = useCategories();

  if (isLoading) {
    return (
      <FormPageContainer>
        <Spin size="large" style={{ margin: 'auto' }} />
      </FormPageContainer>
    );
  }

  const allCategories = categories || [];
  const result = findCategoryInTree(allCategories, Number(id));
  const category = result?.category;

  if (!category) {
    return <Navigate to={ROUTES.CATEGORIES} />;
  }

  const rootCategories = allCategories.filter((c) => c.parentId === null);
  const hasChildren = Boolean(category.children?.length);

  return (
    <FormPageContainer>
      <FormPageHeader>
        <Button type="text" icon={<ArrowLeftOutlined />} onClick={goToList} />
        <h2>Редагувати категорію</h2>
      </FormPageHeader>
      <FormCard>
        <EditCategoryForm
          category={category}
          parentCategories={rootCategories}
          hasChildren={hasChildren}
        />
      </FormCard>
    </FormPageContainer>
  );
};
